import { render, staticRenderFns } from "./LearnerHome.vue?vue&type=template&id=1043155c&"
import script from "./LearnerHome.vue?vue&type=script&lang=ts&"
export * from "./LearnerHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports